import { h } from 'hyperapp';
import cc from 'classcat';
import './index.less';
import Close from '~/common/account/components/close.jsx';
import Avatar from '~/common/account/components/avatar.jsx';
import Title from '~/common/account/components/title.jsx';
import FieldEmail from '~/common/account/components/field-email.jsx';
import FieldCaptcha from '~/common/account/components/field-captcha.jsx';
import FieldEmailCode from '~/common/account/components/field-email-code.jsx';
import FieldName from '~/common/account/components/field-name.jsx';
import FieldPassword from '~/common/account/components/field-password.jsx';
import SendActions from './components/send-actions.jsx';
import RegisterActions from './components/register-actions.jsx';
export default (({
  state,
  actions
}) => h("div", {
  oncreate: element => actions.onCreate({
    element
  }),
  key: "register",
  class: "mc-account mc-register mdui-dialog"
}, h(Close, {
  onClick: actions.close,
  icon: 'close'
}), state.email_valid ? h(Avatar, null) : null, h(Title, {
  text: '创建新账号'
}), h("form", {
  onsubmit: actions.register,
  class: cc([{
    'mdui-hidden': false
  }]),
  key: "submit"
}, h(FieldName, {
  value: state.username,
  message: state.username_msg,
  label: "\u7528\u6237\u540D(\u53EF\u8F93\u5165\u4E2D\u6587)",
  name: "username",
  error: state.username_msg || '用户名不能为空',
  onInput: actions.onInput
}), h(FieldEmail, {
  value: state.email,
  message: state.email_msg,
  label: "\u7535\u5B50\u90AE\u7BB1",
  onInput: actions.onInput
}), h(FieldPassword, {
  value: state.password,
  message: state.password_msg,
  label: "\u5BC6\u7801",
  name: "password",
  onInput: actions.onInput
}), h(RegisterActions, {
  state: state
}))));